var _style, _g, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGjSkillBayLabsLogoPresentation01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464.7 213.6",
    style: {
      enableBackground: "new 0 0 464.7 213.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000067212900993988060720000010515144460145228216_);}\r\n\t.st2{fill:url(#SVGID_00000145018080460348801670000016612547025341720747_);}\r\n\t.st3{fill:url(#SVGID_00000162342334907138945550000009213046427160124573_);}\r\n\t.st4{fill:url(#SVGID_00000088850898085645665030000003772201618526929840_);}\r\n\t.st5{fill:url(#SVGID_00000108293628071991400390000011284690967507094207_);}\r\n\t.st6{fill:url(#SVGID_00000139979106325269388970000012313144223894417811_);}\r\n\t.st7{fill:url(#SVGID_00000130633666536715905290000016407996821960248727_);}\r\n\t.st8{fill:url(#SVGID_00000099658314555458774890000014247618298941765036_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.1,59.8c0-14.5,5.8-21.1,17.8-21.1c4.6,0,8.6,1.1,10.4,1.9l0.3,5.6c-1.9-1-6.2-2.2-10.7-2.2c-8,0-11.7,4.4-11.7,15.8 c0,11.4,3.7,15.8,11.7,15.8c2,0,4-0.3,5.7-0.7V58.3h6v20.5c0,0-4.9,2.2-11.7,2.2C229.9,81,224.1,74.3,224.1,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,79.6l-0.9-5.7c1.6,0.7,5,1.6,8.6,1.6c6,0,9.1-3.2,9.1-10.7V39.5h6v25.3c0,10.6-4.8,16.2-14.7,16.2 C263.5,81,260.3,80.2,258.9,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8,126l-1.3-8.8c3.1,1.1,9.2,2.6,14.5,2.6c5,0,6.7-1.6,6.7-4.2c0-2.2-1.3-3.3-5-4.2l-6.5-1.6 c-6.4-1.5-9.7-5.1-9.7-11.9c0-7.5,4.9-12.3,15.5-12.3c5.9,0,10.9,1.1,13.1,1.9l0.5,8.6c-2.6-0.9-7.8-2.2-12.7-2.2 c-4.7,0-6.3,1.5-6.3,3.7c0,2.4,1.3,3.5,5,4.3l6.3,1.5c6.4,1.5,9.9,4.8,9.9,11.8c0,7.8-4.9,12.7-16.2,12.7 C232.8,128.1,227.3,126.9,224.8,126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.2,111.6l14.1-14.2h-9.9l-6.3,11.1h-2.7V85.9l-9,1.4v39.9h9v-11.7h2.9l6.5,11.7h10.3L273.2,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.6,86.6h9.2v6.9h-9.2V86.6z M291.6,97.4h9.2v29.8h-9.2V97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6,87.3l9.2-1.4v41.3h-9.2V87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5,87.3l9.2-1.4v41.3h-9.2V87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,86.6H357c9.3,0,13.8,3.6,13.8,11c0,3.9-1.4,6.8-4.3,8.6c3.8,1.7,5.4,5,5.4,9.5c0.1,7.6-4.6,11.6-14.3,11.6h-17.8 V86.6z M356.4,103c3.2,0,4.8-1.3,4.8-4.4c0-3.1-1.6-4.4-4.8-4.4h-6.8v8.8H356.4z M356.8,119.5c3.5,0,5.3-1.3,5.3-4.6 c0-3.2-1.8-4.5-5.3-4.5h-7.2v9.1H356.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.8,118.4c0-5.6,3.7-9,10.6-9h6.9v-1c0-3-1.4-4.1-5.7-4.1c-3.5,0-7.4,0.7-9.4,1.3l1.3-7.6c1.8-0.4,5.7-1,9.8-1 c9.2,0,13,4.2,13,11.5v18.8h-7.9l-1.2-3c-1.1,2.2-3.6,3.7-7.9,3.7C379.1,127.8,375.8,124.2,375.8,118.4z M393.3,116.5v-1.8h-5.1 c-2.6,0-3.7,1.1-3.7,3.2c0,2.1,1.2,3.2,3.7,3.2C391.7,121.2,393.3,120.1,393.3,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.6,137.8l-1.4-7.4c0.8,0.3,2.4,0.8,4,0.8c2,0,3.4-0.7,4.3-2.8l0.5-1.3l-11.3-29.7h9.8l6,18.9l5-18.9h9.5L424,130.1 c-2.2,6.3-5.7,8.7-10.4,8.7C411.2,138.8,409.3,138.2,408.6,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3,133.6h9.9v32h18.2l-1.4,8.6h-26.6V133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,165.4c0-5.6,3.7-9,10.6-9h6.9v-1c0-3-1.4-4.1-5.7-4.1c-3.5,0-7.4,0.7-9.4,1.3l1.3-7.6c1.8-0.4,5.7-1,9.8-1 c9.2,0,13,4.2,13,11.5v18.8h-7.9l-1.2-3c-1.1,2.2-3.6,3.7-7.9,3.7C259,174.9,255.7,171.3,255.7,165.4z M273.2,163.6v-1.8h-5.1 c-2.6,0-3.7,1.1-3.7,3.2c0,2.1,1.2,3.2,3.7,3.2C271.6,168.2,273.2,167.1,273.2,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,159.4c0,10.9-3.4,15.5-10.8,15.5c-4.9,0-7.3-2.7-7.9-3.7l-1.2,3h-8v-39.9l9.2-1.4v14.5c0.6-0.9,2.9-3.7,7.9-3.7 C313.1,143.8,316.4,148.5,316.4,159.4z M307.2,159.4c0-6-1.3-8-4.7-8s-4.7,2-4.7,8c0,6,1.2,8,4.7,8S307.2,165.4,307.2,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7,173.2l-1.3-7.6c2.1,0.9,6.6,2.2,11.2,2.2c3.5,0,4.7-0.9,4.7-2.2c0-1.3-0.5-1.9-3-2.3l-4.6-0.9 c-5.9-1.2-8.1-3.9-8.1-9.1c0-5.9,4-9.3,12.8-9.3c4.2,0,8,0.9,9.8,1.5l0.4,7.3c-1.6-0.7-5.3-1.7-9.5-1.7c-3.5,0-4.7,0.8-4.7,2 c0,1.2,0.6,1.8,3.2,2.3l4.4,0.9c5.9,1.2,8.2,3.8,8.2,9.3c0,6.1-3.9,9.5-13.3,9.5C327.8,174.8,323.7,173.9,321.7,173.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.2103,
    y1: 85.0754,
    x2: 190.7281,
    y2: 116.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F47836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09085932,
    style: {
      stopColor: "#F17344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2792,
    style: {
      stopColor: "#EC6260"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5472,
    style: {
      stopColor: "#E53F7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    style: {
      stopColor: "#E43A7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    style: {
      stopColor: "#AF3B89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#713C97"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "189,103.4 122.9,39 144.7,39 209.6,103.4 152.3,174.8 130.8,174.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077321339990613272640000003729405543178336416_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.773,
    y1: 92.7409,
    x2: 189.2908,
    y2: 124.5255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F47836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09085932,
    style: {
      stopColor: "#F17344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2792,
    style: {
      stopColor: "#EC6260"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5472,
    style: {
      stopColor: "#E53F7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    style: {
      stopColor: "#E43A7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    style: {
      stopColor: "#AF3B89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#713C97"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000077321339990613272640000003729405543178336416_)"
    },
    points: "165.5,103.6 123.2,61.4  123.1,46.4 182.1,103.6 123.1,174.8 107.1,174.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071524395187760926200000015890040746301655458_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9321,
    y1: 91.8924,
    x2: 189.4499,
    y2: 123.677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F47836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09085932,
    style: {
      stopColor: "#F17344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2792,
    style: {
      stopColor: "#EC6260"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5472,
    style: {
      stopColor: "#E53F7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    style: {
      stopColor: "#E43A7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    style: {
      stopColor: "#AF3B89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#713C97"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000071524395187760926200000015890040746301655458_)"
    },
    points: "123,84 123,84 140.4,103.4  100.3,153.1 50.7,103.3 99.9,39 78.7,39 29.6,103.3 100.3,174.8 157.4,103.4 139.3,85.4 123.5,69.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140006637011351927620000005298566319671671486_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.0842,
    y1: 111.6042,
    x2: 284.8233,
    y2: 112.3868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F47836"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09085932,
    style: {
      stopColor: "#F17344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2792,
    style: {
      stopColor: "#EC6260"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5472,
    style: {
      stopColor: "#E53F7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    style: {
      stopColor: "#E43A7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    style: {
      stopColor: "#AF3B89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#713C97"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000140006637011351927620000005298566319671671486_)"
    },
    points: "288.2,127.2 276.9,127.2  268.4,117.6 263.2,111.6 268.4,106.3 277.3,97.4 287.4,97.4 273.2,111.6  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGjSkillBayLabsLogoPresentation01);
export default __webpack_public_path__ + "static/media/GJ SkillBay Labs (Logo Presentation)-01.41452a3602b0f483d17ef128299013c3.svg";
export { ForwardRef as ReactComponent };